// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__14XL8","header":"ClearentDisclaimer_header__2nbZS","inner":"ClearentDisclaimer_inner__3gp3n"};